import PropTypes from 'prop-types'
import styles from './Badge.module.css'

const SHAPES = ['fix', 'hug', 'dot']
const COLORS = ['warning', 'error', 'neutral', 'white']

export function Badge({
  shape = 'fix',
  color = 'warning',
  stroke = false,
  className = '',
  style,
  children,
}) {
  const classes = [
    styles.badge,
    styles[`badge--${shape}`],
    styles[`badge--${color}`],
    stroke ? styles['badge--stroke'] : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <span className={classes} style={style}>
      {shape !== 'dot' && children}
    </span>
  )
}

Badge.propTypes = {
  shape: PropTypes.oneOf(SHAPES),
  color: PropTypes.oneOf(COLORS),
  stroke: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
}
